import { useRouter } from 'next/router';

import { forwardRef, useEffect, useMemo, useRef, useState } from 'react';

import styles from './styles.module.scss';

import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBasketShopping, faBoxOpen, faBriefcase, faBrush, faBuilding, faBuildingShield, faCalendarDays, faCalendarWeek, faChartBar, faDoorOpen, faEnvelope, faFileInvoice, faGavel, faGear, faHandHoldingDollar, faHouseChimney, faLocationDot, faMoneyBillTransfer, faRotate, faSearch, faShop, faSquarePlus, faTicket, faToolbox, faUser, faUserEdit, faUserShield, faUserTie, faXmark } from '@fortawesome/free-solid-svg-icons';

import GridIcon from '../Misc/CustomIcons/GridIcon';
import { PuffLoader } from 'react-spinners';

import Messanger from '../Messanger/Messanger';
import { signOut, useSession } from 'next-auth/react';

export default function UniversalHeader() {

  const router = useRouter();
  const { data: session, status } = useSession();

  const [openMenu, setOpenMenu] = useState(false);
  const menuIconRef = useRef(null);
  const gridMenuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (gridMenuRef.current && !gridMenuRef.current.contains(event.target) && !menuIconRef.current.contains(event.target)) {
        setOpenMenu(false);
      }
    }

    // Add event listener when the menu is opened
    if (openMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMenu]);

  function showAdminButton() {
    if(!session) return false;
    if(status === 'loading') return false;
    if(status !== 'authenticated') return false;
    if(session.user.token.username === 'mrgreen33gamer') return true;
  }

  const memoizeMessangerContainer = useMemo(() => <Messanger /> , [session, status])
  const memoizeProfilePictureContainer = useMemo(() => <ProfilePictureContainer /> , [session, status])

  return (
    <header id={styles.headerWrapper}>
      { openMenu && <GridMenu ref={gridMenuRef} closeNav={() => setOpenMenu(false)} /> }
      <section id={styles.navBar}>

        <div id={styles.logoDesktop} onClick={() => router.push('/')}>
          <Image style={{userSelect: 'none', cursor: 'pointer'}} sizes='auto auto' fill objectFit='contain' src='/logo.png' alt='Waco Exchange Logo Desktop' />
        </div>
        <div id={styles.logoMobile} onClick={() => router.push('/')}>
          <div>
            <Image style={{userSelect: 'none'}} sizes='auto auto' fill objectFit='contain' src='/offcial-icon.png' alt='Waco Exchange Logo Mobile' />
          </div>
          <h1>X</h1>
        </div>

        <div id={styles.actions}>
          <div>
            <GridIcon ref={menuIconRef} width={34} ratio={9} color='white' onClick={() => setOpenMenu(!openMenu)} />
          </div>
          { memoizeMessangerContainer }
          { memoizeProfilePictureContainer }
          <div id={styles.adminIcon} style={{display: showAdminButton() ? 'flex' : 'none'}} onClick={() => router.push('/account/admin/dashboard')}>
            <FontAwesomeIcon icon={faUserTie} id={styles.icon} />
          </div>
        </div>

      </section>

    </header>
  )
}

const ProfilePictureContainer = () => {

  const router = useRouter();
  const { data: session, status } = useSession();
  const [pfpLoaded, setPfpLoaded] = useState(false);

  function getUserPfp() {
    const version = new Date().getTime();

    if(session.user.token.pfp === '') return '/profile/defaultUser.jpg';
    return session.user.token.pfp + `?v=${version}`;
  }

  function handleProfileClick(e) {
    e.preventDefault();
    if(status === 'loading') return;
    if(status === 'unauthenticated') return router.push('/account/login');
    if(status === 'authenticated') return router.push('/account/dashboard');
  }

  return (
    <div onClick={handleProfileClick}>
      { !pfpLoaded && <div style={{display: status === 'authenticated' ? 'flex' : 'none'}} id={styles.loadingPfp}> <PuffLoader size={25} color='#154734' /> </div> }
      { status === 'authenticated' && <Image onLoadingComplete={() => setPfpLoaded(true)} sizes='auto auto' objectFit='cover' fill src={getUserPfp()} alt='User Profile Picture' /> }
      { status === 'unauthenticated' && <FontAwesomeIcon icon={faUser} id={styles.icon} color='#154734' /> }
    </div>
  )
}

const GridMenu = forwardRef(({ closeNav }, ref) => {

  const [submenu, setSubmenu] = useState(null);

  const router = useRouter();

  const { data: session, status } = useSession();

  function handleNav(toNav) {
    router.push(toNav)
    closeNav();
  }

  return (
    <nav ref={ref} id={styles.gridMenu}>

      { submenu === null && <section id={styles.mainMenu}>
        <div>
          <button onClick={() => setSubmenu('browse')}> <FontAwesomeIcon icon={faSearch} id={styles.icon} /> <h1>Browse Listings</h1> </button>
          <button onClick={() => setSubmenu('create')}> <FontAwesomeIcon icon={faBrush} id={styles.icon} /> <h1>Content Hub</h1> </button>
          <button onClick={() => setSubmenu('account')}> <FontAwesomeIcon icon={faUser} id={styles.icon} /> <h1>My Account</h1> </button>
          <button onClick={() => handleNav('/financehub')}> <FontAwesomeIcon icon={faMoneyBillTransfer} id={styles.icon} /> <h1>My Finances</h1> </button>
          <button onClick={() => setSubmenu('resources')}> <FontAwesomeIcon icon={faBuildingShield} id={styles.icon} /> <h1>Resources</h1> </button>
          { session && <button onClick={() => signOut({ callbackUrl: `/` })}> <FontAwesomeIcon icon={faDoorOpen} id={styles.icon} /> <h1>Logout</h1> </button> }
        </div>

      </section> }

      {
        submenu === 'browse' && <section>
        <section>
          <h1>Browse Listings</h1>
          <FontAwesomeIcon onClick={() => setSubmenu(null)} icon={faXmark} id={styles.back} />
        </section>
        <div>
          <button onClick={() => handleNav('/marketplace/buysell')}> <FontAwesomeIcon icon={faHandHoldingDollar} id={styles.icon} /> <h1>Marketplace</h1> </button>
          <button onClick={() => handleNav('/marketplace/trading')}> <FontAwesomeIcon icon={faRotate} id={styles.icon} /> <h1>Trading</h1> </button>
          <button onClick={() => handleNav('/marketplace/estate')}> <FontAwesomeIcon icon={faHouseChimney} id={styles.icon} /> <h1>Estate</h1> </button>
          <button onClick={() => handleNav('/marketplace/rentals')}> <FontAwesomeIcon icon={faBuilding} id={styles.icon} /> <h1>Rentals</h1> </button>
          <button onClick={() => handleNav('/marketplace/garageyardsales')}> <FontAwesomeIcon icon={faBasketShopping} id={styles.icon} /> <h1>Garage Sales</h1> </button>
          <button onClick={() => handleNav('/marketplace/vendors')}> <FontAwesomeIcon icon={faShop} id={styles.icon} /> <h1>Vendors</h1> </button>
          <button onClick={() => handleNav('/marketplace/products')}> <FontAwesomeIcon icon={faBoxOpen} id={styles.icon} /> <h1>Products</h1> </button>
          <button onClick={() => handleNav('/marketplace/services')}> <FontAwesomeIcon icon={faToolbox} id={styles.icon} /> <h1>Services</h1> </button>
          <button onClick={() => handleNav('/marketplace/auctions')}> <FontAwesomeIcon icon={faGavel} id={styles.icon} /> <h1>Auctions</h1> </button>
          <button onClick={() => handleNav('/marketplace/events')}> <FontAwesomeIcon icon={faCalendarWeek} id={styles.icon} /> <h1>Events</h1> </button>
          <button onClick={() => handleNav('/marketplace/businesses')}> <FontAwesomeIcon icon={faLocationDot} id={styles.icon} /> <h1>Biz Maps</h1> </button>
          <button onClick={() => handleNav('/marketplace/jobs')}> <FontAwesomeIcon icon={faBriefcase} id={styles.icon} /> <h1>Jobs</h1> </button>
        </div>
      </section>
      }

      {
        submenu === 'create' && <section>
        <section>
          <h1>Content Hub</h1>
          <FontAwesomeIcon onClick={() => setSubmenu(null)} icon={faXmark} id={styles.back} />
        </section>
        <div>
          <button onClick={() => handleNav('/account/dashboard')}> <FontAwesomeIcon icon={faChartBar} id={styles.icon} /> <h1>Dashboard</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/management/marketplace')}> <FontAwesomeIcon icon={faHandHoldingDollar} id={styles.icon} /> <h1>Marketplace</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/management/auctions')}> <FontAwesomeIcon icon={faGavel} id={styles.icon} /> <h1>Auctions</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/management/vendor')}> <FontAwesomeIcon icon={faShop} id={styles.icon} /> <h1>My Vendor</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/management/events')}> <FontAwesomeIcon icon={faCalendarDays} id={styles.icon} /> <h1>Events</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/management/businesses')}> <FontAwesomeIcon icon={faBuilding} id={styles.icon} /> <h1>Biz Maps</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/management/jobs')}> <FontAwesomeIcon icon={faBriefcase} id={styles.icon} /> <h1>Jobs</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/management/raffles')}> <FontAwesomeIcon icon={faTicket} id={styles.icon} /> <h1>Raffles</h1> </button>
        </div>
      </section>
      }

      {
        submenu === 'account' &&  <section>
        <section>
          <h1>My Account</h1>
          <FontAwesomeIcon onClick={() => setSubmenu(null)} icon={faXmark} id={styles.back} />
        </section>
        <div>
          <button onClick={() => handleNav('/account/dashboard/account/profile')}> <FontAwesomeIcon icon={faUserEdit} id={styles.icon} /> <h1>Profile</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/account/security')}> <FontAwesomeIcon icon={faUserShield} id={styles.icon} /> <h1>Security</h1> </button>
          <button onClick={() => handleNav('/account/dashboard/account/settings')}> <FontAwesomeIcon icon={faGear} id={styles.icon} /> <h1>Settings</h1> </button>
        </div>
      </section>
      }

      {
        submenu === 'resources' && <section>
        <section>
          <h1>Resources</h1>
          <FontAwesomeIcon onClick={() => setSubmenu(null)} icon={faXmark} id={styles.back} />
        </section>
        <div>
          <button onClick={() => handleNav('/resources/contact')}> <FontAwesomeIcon icon={faEnvelope} id={styles.icon} /> <h1>Contact Us</h1> </button>
          <button onClick={() => handleNav('/resources/policies')}> <FontAwesomeIcon icon={faBuildingShield} id={styles.icon} /> <h1>Policies</h1> </button>
        </div>
      </section>
      }


    </nav>
  );
});

/*





      <section>
        <h1>Finance</h1>
        <div>
          <button onClick={() => handleNav('/financehub')}> <FontAwesomeIcon icon={faCoins} id={styles.icon} /> <h1>My Finances</h1> </button>
        </div>
      </section>

      <section>
        <h1>Resources</h1>
        <div>
          <button onClick={() => handleNav('/resources/about')}> <FontAwesomeIcon icon={faFileInvoice} id={styles.icon} /> <h1>About Us</h1> </button>
          <button onClick={() => handleNav('/resources/contact')}> <FontAwesomeIcon icon={faEnvelope} id={styles.icon} /> <h1>Contact Us</h1> </button>
          <button onClick={() => handleNav('/resources/policies')}> <FontAwesomeIcon icon={faBuildingShield} id={styles.icon} /> <h1>Policies</h1> </button>
        </div>
      </section>

      <section>
        <div>
        { session && <button id={styles.logoutButton} onClick={() => signOut({ callbackUrl: `/` })}> <FontAwesomeIcon icon={faDoorOpen} id={styles.icon} /> <h1>Logout</h1></button> }
        </div>
      </section>

*/

GridMenu.displayName = 'GridMenu';